export default "__VITE_ASSET__BFDqif5U__"